module.exports = __webpack_public_path__ + "media/images/lb/328-9ebaf9064e27b388c4541dc9092d251b.svg";